import { Box, CircularProgress, Skeleton, Typography } from '@mui/material';
import { WD } from './warningTheme';

// Shown in the content area while a dashboard's first fetch is in flight. Calculations run live on the
// server (cached afterwards), so the first load can take a few seconds - a bare spinner beside the month
// picker left the page looking blank/broken, so say what is happening and hold the space with a skeleton.
const WarningLoading = ({ message = 'Calculating results for the selected month - the first load can take a few seconds…' }) => (
  <Box role="status" aria-live="polite">
    <Box display="flex" alignItems="center" gap={1.5} sx={{ mb: 2 }}>
      <CircularProgress size={18} sx={{ color: WD.green }} />
      <Typography sx={{ fontSize: 14, color: WD.inkMuted }}>{message}</Typography>
    </Box>
    <Skeleton variant="rounded" height={64} sx={{ mb: 1.5, borderRadius: '12px' }} />
    {[0, 1, 2, 3, 4].map((i) => (
      <Skeleton key={i} variant="rounded" height={40} sx={{ mb: 1, borderRadius: '8px' }} />
    ))}
  </Box>
);

export default WarningLoading;
